<template>
  <div class="tab-bar" :style="tab_height" :class="{ 'top-fixed': top_fixed }">
    <div
      class="tab-item"
      :class="{ active: index === value }"
      v-for="(item, index) in list"
      @click="TabClick(index)"
      :style="tab_height"
      :key="index">
      {{item.title}}
      <span :style="label_style"></span>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      TabClick (index) {
        this.$emit('input', index)
        this.$emit('clickTab', index)
      }
    },
    computed: {
      tab_height () {
        return `height: ${this.height}rem`
      },
      label_style () {
        return `width: ${this.label_width}rem`
      }
    },
    props: {
      list: null,
      value: null,
      label_width: {
        type: null,
        default: 0.7
      },
      top_fixed: {
        type: Boolean,
        default: false
      },
      height: {
        type: null,
        default: 0.8
      }
    }
  }
</script>

<style lang="less" scoped>
  .tab-bar {
    .bg(#fff);
    display: flex;
    .tab-item {
      flex: 1;
      .h(.8rem);
      .flex-cc();
      .fz(.32rem);
      .c(#999);
      text-align: center;
      span {
        display: block;
        position: absolute;;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        .h(.08rem);
        .br(.08rem);
      }
      &.active {
        .c(#00b0f4);
        font-weight: bold;
        position: relative;
        span {
          .bg(#00b0f4);
        }
      }
    }
  }
</style>
